/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datagrid_Dragtoreorder3Inputs */

const en_datagrid_dragtoreorder3 = /** @type {(inputs: Datagrid_Dragtoreorder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag to reorder`)
};

/**
* | output |
* | --- |
* | "Drag to reorder" |
*
* @param {Datagrid_Dragtoreorder3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const datagrid_dragtoreorder3 = /** @type {((inputs?: Datagrid_Dragtoreorder3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datagrid_Dragtoreorder3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_datagrid_dragtoreorder3(inputs)
});
export { datagrid_dragtoreorder3 as "dataGrid_dragToReorder" }